export default __webpack_public_path__ + "static/media/ExploreTheDeep_04.8b1abc59.png";